import React, { Component } from "react";
import classNames from "classnames";
import CreaterForApp from "./CreaterForApp";
import chart01Preview from "Assets/images/widgetimg/chart01Preview.png";
//拖拽预览组件类
export default class CardListDragPreview extends Component {
    constructor(props) {
        super(props);
    }
    //当拖拽的siderCard的数量变化时，重新渲染
    shouldComponentUpdate(nextProps, nextState) {
        if (this.props.cardListLength !== nextProps.cardListLength) {
            return true;
        }
        return false;
    }

    //渲染拖拽预览
    renderDragPreview = (index, myIndex, emptyContent) => {
        const { item, cardListLength } = this.props;
        const { width, height, margin } = window.workbenchGridItemSize;
        const previewSize = { // 预览尺寸
            w: 4,
            h: 4,
        };
        const style =
            item.apptype === "1"
                ? {
                      left: `${myIndex * 5}px`,
                      top: `${myIndex * 5}px`,
                      width: width * previewSize.w + margin * (previewSize.w - 1),
                      height: height * previewSize.h + margin * (previewSize.h - 1),
                  }
                : {
                      left: `${myIndex * 5}px`,
                      top: `${myIndex * 5}px`,
                  };
        const previewContent = !emptyContent && (
            <React.Fragment>
                {cardListLength !== 1 && (
                    <span className="layer-card-span">＋{cardListLength}</span>
                )}
                {this.renderDragPreviewItem(item)}
            </React.Fragment>
        );
        return (
            <div
                key={index}
                className={classNames("layer-card", {
                    bcBlack: window.nccColor && window.nccColor === "black",
                    scale: item.apptype === "1",
                })}
                style={style}
            >
                {previewContent}
            </div>
        );
    };

    renderDragPreviewItem = (item) => {
        if (item.apptype === "1") {
            //应用预览显示实际内容
            return <CreaterForApp key={item.cardid} appData={item} isPreview/>;
        } else if (item.apptype === "2") {
            const imgSrc = item.image_src || "/othericon";
            let bgUrl = "";
            try {
                bgUrl = require(`Assets/images/widgetimg${imgSrc}Preview.png`);
            } catch (error) {
                bgUrl = require(`Assets/images/widgetimg/othericonPreview.png`);
            }
            //部件预览显示占位图
            return (
                <div className="widget-preview">
                    <div className="widget-preview-name">{item.name}</div>
                    <div
                        className="widget-preview-content"
                        style={{
                            backgroundImage: `url(${bgUrl})`,
                        }}
                    ></div>
                </div>
            );
        }
    };
    render() {
        const { cardListLength, item } = this.props;
        let divDom = [];
        for (let index = 0; index < cardListLength; index++) {
            //第一个显示layer的dom，需要显示图片和数量红色气泡
            if (index === cardListLength - 1) {
                const myIndex = index >= 3 ? 3 : index;
                const previewDom = this.renderDragPreview(index, myIndex);
                divDom.push(previewDom);
            } else if (index < 3) {
                //layer的dom最多显示四个
                const previewDom = this.renderDragPreview(index, index, true);
                divDom.push(previewDom);
            }
        }
        return <div className="desk-setting-layer-card-list">{divDom}</div>;
    }
}
